import { memo } from "react"
import { Image } from "@chakra-ui/image"
import styled from "styled-components"

import IconShelfWhite from "components/EvtKit/icons/IconShelfWhite"

const Container = styled.div`
  object-fit: contain;
  width: 100%;
  margin-bottom: 56px;
  padding-left: 24px;
`

interface LogoSidebarProps {
  src: string
}

function LogoSidebar(props: LogoSidebarProps) {
  const { src } = props

  return (
    <>
      {!!src && <Image objectFit="contain" w="136px" h="72px" mb="56px" ml="0px !important" src={src} />}

      {!src && (
        <Container>
          <IconShelfWhite />
        </Container>
      )}
    </>
  )
}

export default memo(LogoSidebar)
